export default __webpack_public_path__ + "static/media/slide3.452a1ed3.png";